module.exports = __webpack_public_path__ + "assets/a83a1786380947fd971e24fc605119dc.mp3";